import React from 'react';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import GridContainer from 'components/Grid/GridContainer';
import { translate } from 'components/Translation';
import InformationCard from './Subcomponents/InformationCard';
import { SingleRequest } from 'utils/api/models/requests/singleRequest';

interface IActivityDetailsProps {
	userRequest: SingleRequest | null;
	isOpen: boolean;
	turnOffDialog: () => void;
	refetchUserRequests: () => void;
}

export enum Status {
	ACCEPTED = 'ACCEPTED',
	REJECTED = 'REJECTED',
	PENDING = 'PENDING',
	NEW = 'NEW',
}

const ServiceRequestDialog = ({ userRequest, isOpen, turnOffDialog, refetchUserRequests }: IActivityDetailsProps) => {
	return (
		<CustomDialog
			header={translate('activities.details.activity.details')}
			isOpen={isOpen}
			hideDialog={turnOffDialog}
			width={588}
			dialogBody={
				<div style={{ overflowX: 'hidden' }}>
					<GridContainer justify="center" direction="column" alignContent="center">
						<div style={{ width: 400 }}>
							<InformationCard
								requestInfo={userRequest ? userRequest.reqParam : null}
								requestType={userRequest?.userReqType}
								amount={userRequest ? userRequest.amount : null}
							/>
						</div>
					</GridContainer>
				</div>
			}
		/>
	);
};

export default ServiceRequestDialog;
